import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class HttpLoadingService {
	private pendingRequests = 0;
	private loadingSubject = new BehaviorSubject<boolean>(false);
	isLoading$ = this.loadingSubject.asObservable();

	start(): void {
		this.pendingRequests++;
		this.loadingSubject.next(true);
	}

	stop(): void {
		this.pendingRequests = Math.max(0, this.pendingRequests - 1);
		if (this.pendingRequests === 0) {
			this.loadingSubject.next(false);
		}
	}
}
